import styled, { css } from 'styled-components';
import theme from 'styled-theming';

const StyledButton = css`
  z-index: 2;
  position: absolute;
  padding: 0 30px;
  height: 86.5%;
  outline: 0;
  border: 0;
  cursor: pointer;
`;

export const PrevButton = styled.button`
  ${StyledButton};
  display: ${props => (props.hasPrev ? 'block' : 'none')};
  background:
    linear-gradient(
      to right,
      ${theme('mode', { light: 'rgba(255, 255, 255, 0.8)', dark: 'rgba(39, 39, 39, 1)' })} 0%,
      ${theme('mode', { light: 'rgba(255, 255, 255, 0)', dark: 'rgba(0, 0, 0, 0)' })} 100%
    );
  left: -10px;

  @media ( max-width: 768px ) {
    display: none;
  }
`;

export const NextButton = styled.button`
  ${StyledButton};
  display: ${props => (props.hasNext ? 'block' : 'none')};
  background:
    linear-gradient(
      to left,
      ${theme('mode', { light: 'rgba(255, 255, 255, 0.8)', dark: 'rgba(39, 39, 39, 1)' })} 0%,
      ${theme('mode', { light: 'rgba(255, 255, 255, 0)', dark: 'rgba(0, 0, 0, 0)' })} 100%
    );
  right: 0;

  @media ( max-width: 768px ) {
    display: none;
  }
`;
